import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../features/auth/authSlice";
import notificationReducer from "../features/auth/notificationSlice";

// Persist config only for auth slice
const authPersistConfig = {
  key: "auth",
  storage,
};

// Create a persisted version of the auth reducer
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

// Root reducer with both persisted and normal reducers
const rootReducer = {
  auth: persistedAuthReducer,
  notification: notificationReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'], // optional: suppress redux-persist warnings
      },
    }),
});

export const persistor = persistStore(store);
